import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toast } from 'sonner';
import { Mail, Send, Info } from 'lucide-react';

/**
 * ForwardingAddresses — the per-tenant Mailgun forwarding addresses
 * (`<companyId>+invoice@…`, `<companyId>+receipt@…`). Forwarding a PDF to one
 * of these is an email intake channel, so this lives in the E-postinkorg
 * settings tab alongside the connected mailboxes and the blocklist.
 *
 * Uses the same `modern-card` design language as the rest of CompanySettings.
 */
export default function ForwardingAddresses({ companyId }) {
    const domain = process.env.REACT_APP_INVOICE_MAIL_DOMAIN || 'mail.ledgerloop.ai';
    const rows = [
        { type: 'invoice', label: 'Fakturor' },
        { type: 'receipt', label: 'Kvitton' },
    ];

    return (
        <div className="modern-card">
            <div className="modern-card-header">
                <div>
                    <h2 className="section-title">
                        <Send size={16} />
                        Vidarebefordra fakturor hit
                    </h2>
                    <p className="section-subtitle">
                        Skicka eller vidarebefordra dokument (PDF) till adresserna nedan så hamnar de
                        automatiskt i Inkorgen och bearbetas.
                    </p>
                </div>
            </div>

            <div className="modern-card-body">
                {rows.map(({ type, label }) => {
                    const emailAddr = `${companyId}+${type}@${domain}`;
                    return (
                        <div
                            key={type}
                            style={{
                                display: 'flex', alignItems: 'center', gap: 12,
                                padding: '12px 16px', borderRadius: 10,
                                background: '#f9fafb', border: '1px solid #e5e7eb',
                                marginBottom: 8,
                            }}
                        >
                            <Mail size={16} style={{ color: '#6b7280', flexShrink: 0 }} />
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: 500, marginBottom: 1 }}>{label}</div>
                                <code style={{ fontSize: '0.9rem', fontWeight: 600, color: '#111827', background: 'transparent', wordBreak: 'break-all' }}>
                                    {emailAddr}
                                </code>
                            </div>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                style={{ borderRadius: 6, flexShrink: 0 }}
                                onClick={() => {
                                    navigator.clipboard.writeText(emailAddr);
                                    toast.success('E-postadress kopierad');
                                }}
                            >
                                Kopiera
                            </Button>
                        </div>
                    );
                })}
                <div className="d-flex align-items-center gap-1 mt-1">
                    <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip>Tipsa dina leverantörer om att skicka fakturor direkt till faktura-adressen, eller ställ in automatisk vidarebefordring i din e-postklient.</Tooltip>}
                    >
                        <div className="d-flex align-items-center gap-1" style={{ cursor: 'help' }}>
                            <Info size={14} style={{ color: '#9ca3af' }} />
                            <span style={{ fontSize: '0.78rem', color: '#9ca3af' }}>Hur använder jag dessa adresser?</span>
                        </div>
                    </OverlayTrigger>
                </div>
            </div>
        </div>
    );
}
